<template>
  <Section v-bind="$attrs" class="section_gradient">
    <div
      :id="ID_CONTACT"
      class="-body text-align-left text-line-normal text-lighter"
      itemscope
      itemtype="https://schema.org/LegalService"
    >
      <div class="sr-only" itemprop="name">{{ texts.brand_name_long }}</div>
      <div class="-links">
        <RouterLink
          :to="{ name: ROUTE_HOME }"
          class="fx_outline"
          :style="{ fontSize: '2rem', color: colors.brand_main }"
        >
          <LogoNew />
        </RouterLink>
        <a
          :href="`https://maps.google.com/?q=600 Corporate Pointe, Culver City, CA 90230, USA`"
          class="-link fx_outline"
          target="_blank"
          itemprop="hasMap"
        >
          <NIcon size="32" depth="5"><IconLocation /></NIcon>
          <div
            itemprop="address"
            itemscope
            itemtype="https://schema.org/PostalAddress"
          >
            <span itemprop="streetAddress">600 Corporate Pointe</span>, Suite
            215
            <br />
            <span itemprop="addressLocality">Culver City</span>,
            <span itemprop="addressRegion">CA</span>
            <span itemprop="postalCode">90230</span>
          </div>
        </a>
        <a
          href="tel:+12132359190"
          class="-link fx_outline"
          itemprop="telephone"
        >
          <NIcon size="32" depth="5"><IconPhone /></NIcon>
          (213) 235-9190
        </a>
        <button
          type="button"
          aria-haspopup="dialog"
          @click="contactForm.open()"
          class="-link fx_outline"
        >
          <NIcon size="32" depth="5"><IconMail /></NIcon>
          Message Us
        </button>
      </div>
    </div>
    <template #footer>
      <span class="text-size-small text-align-center opacity-50">
        © 2019-{{ new Date().getFullYear() }} {{ texts.brand_name_long }}
      </span>
    </template>
  </Section>
  <ContactForm ref="contactForm" />
</template>

<style scoped lang="scss">
.-links {
  display: grid;
  grid-auto-rows: auto 1fr;
  gap: 0.5rem;
}
.-link {
  display: flex;
  align-items: center;
  padding: 0.5rem 1rem;
  gap: 0.5em;
}
</style>

<script setup>
defineOptions({ name: "PageFooter" });
import { NIcon } from "naive-ui";
import { ref } from "vue";
import { RouterLink } from "vue-router";
import ContactForm from "../ContactForm.vue";
import Section from "../../components/Section.vue";
import LogoNew from "../../components/LogoNew.vue";
import { IconMail, IconLocation, IconPhone } from "../../components/icons.js";
import colors from "../../colors.js";
import { ROUTE_HOME } from "../../routing/routes.js";
import texts from "../../texts.json";
import { ID_CONTACT } from "../../variables.js";

const contactForm = ref(null);
</script>
